export default __webpack_public_path__ + "static/media/Library.70d0a6a9.svg";